module.exports = __webpack_public_path__ + "static/media/hs-kids.4ce7b4b0.png";